//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import comicobject from "../script/comicobject";

export default {
  name: "recommand.rank",
  data() {
    return {
      comicobject: comicobject,
      ROW_COUNT: this._g.COMMON_ROW_COUNT,
      g: this._g,
      recomand_datas: undefined
    }
  },
  created() {
    this.listener_init = this.$hub.on('event:init', () => {
      console.log('event init call');
      this.recomand_datas = this.$store.state.init.data.recomand_datas;
      this.$forceUpdate();
    });
    try {
      this.recomand_datas = this.$store.state.init.data.recomand_datas;
    } catch (e) {

    }
  },
  destroyed() {
    this.listener_init.off();
  },
}
